import { render, staticRenderFns } from "./PostQuestion.vue?vue&type=template&id=f98f9238&scoped=true&"
import script from "./PostQuestion.vue?vue&type=script&lang=js&"
export * from "./PostQuestion.vue?vue&type=script&lang=js&"
import style0 from "./PostQuestion.vue?vue&type=style&index=0&id=f98f9238&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f98f9238",
  null
  
)

export default component.exports